import { useSignOut } from "@/apis/hooks/auth/signing";
import useInactivityLogout from "@/hooks/useInactivityLogout";

export default function InactivityHandler() {
  const { mutate: signOut } = useSignOut();

  useInactivityLogout(() => {
    signOut();
  });

  return null;
}
